function initMobileMenuButton() {
  const overlay = document.querySelector(".js-mobile-menu-overlay");
  const transparentOverlay = document.querySelector(".js-mobile-menu-transparent-overlay");
  const openButton = document.querySelector(".js-mobile-menu-button_open");
  const closeButton = document.querySelector(".js-mobile-menu-button_close");

  if (!openButton) {
    return;
  }

  openButton.addEventListener("click", function () {
    overlay.classList.add("show");
    transparentOverlay.classList.add("show");
  });

  if (!closeButton) {
    return;
  }

  closeButton.addEventListener("click", function () {
    overlay.classList.remove("show");
    transparentOverlay.classList.remove("show");
  });
}

function initForumReplyForm() {
  document.addEventListener('DOMContentLoaded', function () {
    var textarea = document.getElementById('bbp_reply_content');
    if (textarea) {
      textarea.setAttribute('placeholder', 'Write your message here...');
    }
  });
}

initMobileMenuButton();
initForumReplyForm();
